
import './index.css';
import Login from './component/login';
import Signup from './component/signup';
import { Route, Routes } from 'react-router-dom'

function App() {
  return (
    <>
      <Routes>ff
        <Route path='/' element={<Login />} />
        <Route path='/signup' element={<Signup />} />


      </Routes>
    </>
  );
}

export default App;
